export const TEST_IDS = {
  SEARCH_SUGGESTIONS_LIST: "search-suggestions-list",
  ADD_TO_CART_BUTTON: "add-to-cart-button",
  ADD_TO_CART_BOTTOM_SHEET: "add-to-cart-bottom-sheet",
  ADD_TO_CART_CONFIRM_BUTTON: "add-to-cart-confirm-button",
  SUCCESS_TOAST: "success-toast",
  CREATE_ORDER_BUTTON: "create-order-button",
  CREATE_ORDER_CONFIRM_BUTTON: "create-order-confirm-button",
  CREATE_ORDER_BOTTOM_SHEET: "create-order-bottom-sheet",
  TOAST_ITEM: "toast-item",
  SEARCH_LIST_PRODUCT_ITEM: "search-list-product-item",
  CART_ITEM: "cart-item",
  ORDER_ITEM_TITLE: "order-item-title",
  HEADER_CART_BUTTON: "header-cart-button",
  ORDER_CREATED_BOTTOM_SHEET: "order-created-bottom-sheet",
  ORDER_CREATED_DISMISS_BUTTON: "order-created-dismiss-button",
};
